import Vue from 'vue'
import { instance, errorService, savePreviousData } from '@/services/api'
import { dropdownAPIs, projectAPIs } from '@/services/authConstantsV1'
import { filterTakeoffGrid, filterTakeoff } from '@/services/grid'
import { Select, Modal } from 'ant-design-vue'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import _ from 'lodash'

Vue.use(Select)
Vue.use(Modal)

export default Vue.extend({
  components: {
    'ag-grid-vue': AgGridVue,
  },
  template: `
      <div class="a-gcell certain-category-search-wrapper">
        <a-spin :spinning="loading">
          <a-auto-complete
            class="w-100 certain-category-search"
            size="small"
            v-model="value"
            :value="value"
            option-label-prop="value"
            style="width: 200px"
            @focus="savePreviousData(value)"
            @search="onSearch($event)"
            @select="saveData"
            :autoFocus="true"
            ref="txt-autocomplete-takeoff"
            dropdown-class-name="certain-category-search-dropdown"
          >
            <template slot="dataSource">
              <a-select-opt-group
                v-for="(result, index) in takeoffs"
                :key="result.index"
              >
                <span slot="label" class="select-text">
                  {{ result.takeoffGrouping }}
                </span>
                <a-select-option
                  v-for="item in result.takeoffs"
                  :key="item.key"
                  :value="item.key"
                >
                  <a-tooltip
                    placement="left"
                    :title="
                      item.takeoff +
                        ' - ' +
                        formatCurrency(item.unitCost) +
                        ' - ' +
                        item.unit +
                        ' - ' +
                        formatLife(item.life) +
                        '(' +
                        item.assetClass +
                        ')' +
                        ' - ' +
                        item.categoryCode
                    "
                  >
                    <a-row :gutter="10">
                      <a-col :span="7">
                        <span class="autocomplete-list">
                          {{ item.takeoff }}
                        </span>
                      </a-col>
                      <a-col :span="6">
                        <span class="autocomplete-list">
                          {{ formatCurrency(item.unitCost) }}
                        </span>
                      </a-col>
                      <a-col :span="3">
                        <span class="autocomplete-list">
                          {{ item.unit }}
                        </span>
                      </a-col>
                      <a-col :span="5">
                        <span class="autocomplete-list" v-if="item.assetClass">
                          {{ formatLife(item.life) }} ({{ item.assetClass }})
                        </span>
                        <span class="autocomplete-list" v-else>
                          {{ formatLife(item.life) }}
                        </span>
                      </a-col>
                      <a-col :span="3">
                        <span class="autocomplete-list">
                          {{ item.categoryCode }}
                        </span>
                      </a-col>
                    </a-row>
                  </a-tooltip>
                </a-select-option>
              </a-select-opt-group>
              <a-select-option
                key="all"
                value="viewAll"
                class="show-all"
                v-if="count > limit"
              >
                <a class="view-all">
                  View all results
                </a>
              </a-select-option>
            </template>
          </a-auto-complete>
        </a-spin>
        <a-modal
          title="Takeoff"
          :visible="visible"
          @ok="handleOk"
          @cancel="handleCancel"
          :maskClosable="false"
          centered
          :destroyOnClose="true"
          :width="1200"
          :height="800"
          :bodyStyle="{ padding: '5px 24px 10px !important', height: '700px' }"
          :footer="null"
          wrapClassName="modal-wrap"
        >
          <a-input
            v-model="searchText"
            placeholder="Search Takeoffs/Takeoff Groupings"
            class="mb-2"
            @change="onChange"
          >
            <template slot="suffix">
              <a-button
                type="link"
                icon="close-circle"
                :style="{ padding: '0px', fontSize: '18px' }"
                @click="clearFilter"
              />
            </template>
          </a-input>
          <div class="table" style="height: 100%; box-sizing: border-box">
            <a-spin tip="Loading..." :spinning="loading">
              <div style="height: 100%; width: 100%">
                <ag-grid-vue
                  :style="{ width, height }"
                  class="ag-theme-alpine"
                  id="takeoffTable"
                  :gridOptions="gridOptions"
                  @grid-ready="getData"
                  :animateRows="true"
                  suppressLoadingOverlay="true"
                  tooltipShowDelay="0"
                  :frameworkComponents="frameworkComponents"
                  @selection-changed="onSelectionChanged"
                >
                </ag-grid-vue>
              </div>
            </a-spin>
          </div>
        </a-modal>
      </div>
    `,

  data() {
    return {
      takeoffs: [],
      prevSearchKey: '',
      prevResult: [],
      value: null,
      savePreviousData: savePreviousData,
      loading: false,
      role: null,
      takeoffData: undefined,
      takeoff: undefined,
      visible: false,
      gridOptions: null,
      columnDefs: [],
      width: '100%',
      height: '50em',
      list: [],
      count: 0,
      limit: process.env.VUE_APP_TAKEOFF_COUNT,
      searchText: undefined,
    }
  },
  beforeMount() {
    this.loadConfig()
  },
  created() {
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.role = user.role
    this.prevSearchKey = undefined
    this.prevResult = []
    this.takeoffs = []
    this.value = undefined
    if (this.params.value) {
      this.takeoff = this.params.value
      this.value = this.params.value
      const searchText = this.params.value
      this.onLoadSearch(searchText)
    }
  },
  methods: {
    loadConfig() {
      const cellClassRules = {
        'show-cell': 'data.section === "col-span"',
      }
      this.frameworkComponents = {
        costPriceCellRenderer: CurrencyRenderer,
      }
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        singleClickEdit: false,
        stopEditingWhenGridLosesFocus: false,
        tooltipShowDelay: 0,
        rowSelection: 'single',
        defaultColDef: {
          resizable: false,
          sortable: true,
          editable: false,
          suppressMovable: true,
          singleClickEdit: false,
        },
      }
      this.columnDefs = [
        {
          headerName: 'Takeoff',
          field: 'takeoff',
          tooltipField: 'takeoff',
          width: 400,
          headerTooltip: 'Takeoff',
          sortable: false,
          floatingFilter: false,
          colSpan: params => {
            if (params.data.section === 'col-span') {
              return 6
            } else {
              return 1
            }
          },
          cellClassRules: cellClassRules,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          width: 60,
          headerTooltip: 'Unit Cost',
          sortable: false,
          floatingFilter: false,
          cellRenderer: 'costPriceCellRenderer',
        },
        {
          headerName: 'Unit',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          field: 'unit',
          width: 50,
          headerTooltip: 'Unit',
          sortable: false,
          floatingFilter: false,
        },
        {
          headerName: 'Life (In Years)',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          field: 'life',
          width: 60,
          headerTooltip: 'Life (In Years)',
          sortable: false,
          floatingFilter: false,
        },
        {
          headerName: 'Asset Class',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          field: 'assetClass',
          width: 60,
          headerTooltip: 'Asset Class',
          sortable: false,
          floatingFilter: false,
        },
        {
          headerName: 'Category Code',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          field: 'categoryCode',
          tooltipField: 'categoryCode',
          width: 80,
          headerTooltip: 'Category Code',
          sortable: false,
          floatingFilter: false,
        },
      ]
    },
    getData(params) {
      params.api.setColumnDefs(this.columnDefs)
      params.api.setRowData(this.list)
      params.api.sizeColumnsToFit()
    },

    formatCurrency(value) {
      const settings = JSON.parse(localStorage.getItem('userSettings'))
      return new Intl.NumberFormat(settings.currency.currencyFormate, {
        style: 'currency',
        currency: settings.currency.currency,
      }).format(value)
    },

    formatLife(value) {
      if (value > 1) {
        return `${value} Years`
      } else {
        return `${value} Year`
      }
    },

    onSearch(searchText) {
      const searchString = searchText
      if (!this.visible) {
        this.searchText = searchText
      }
      searchText = searchText.slice(0, 3)
      let url = `${dropdownAPIs.takeoff}?search=${searchText.slice(0, 3)}`
      if (this.params.colDef.cellRendererParams.screen === 'Project') {
        url = `${projectAPIs.master.takeoff.add(
          this.$route.params.id,
        )}?search=${searchText.slice(0, 3)}`
      }
      if (
        (this.prevSearchKey !== searchText && searchText.length === 3) ||
        (!this.prevSearchKey && searchString.length >= 3)
      ) {
        this.takeoffs = []
        this.prevSearchKey = searchString
        this.loading = true
        instance
          .get(`${url}`)
          .then(res => {
            const result = _.get(res.data, 'result', [])
            this.list = []
            this.prevResult = JSON.stringify(result)
            this.loading = false
            const oldData =
              this.prevResult.length > 0 && searchString
                ? JSON.parse(this.prevResult)
                : []
            this.searchTakeoff(oldData, searchString)
          })
          .catch(err => {
            this.loading = false
            errorService(err)
          })
      } else {
        const oldData =
          this.prevResult.length > 0 && searchString
            ? JSON.parse(this.prevResult)
            : []
        this.searchTakeoff(oldData, searchString)
      }
    },

    onChange(event) {
      this.getTakeoffs(event.target.value)
    },

    onLoadSearch(searchText) {
      const searchString = searchText
      if (!this.visible) {
        this.searchText = searchText
      }
      let url = `${dropdownAPIs.takeoff}?search=${searchText.slice(0, 3)}`
      if (this.params.colDef.cellRendererParams.screen === 'Project') {
        url = `${projectAPIs.master.takeoff.add(
          this.$route.params.id,
        )}?search=${searchText.slice(0, 3)}`
      }
      this.takeoffs = []
      this.prevSearchKey = searchText
      this.loading = true
      instance
        .get(`${url}`)
        .then(res => {
          const result = _.get(res.data, 'result', [])
          this.list = []
          this.prevResult = JSON.stringify(result)
          const oldData =
              this.prevResult.length > 0 && searchString
                ? JSON.parse(this.prevResult)
                : []
          this.searchTakeoff(oldData, searchString)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    searchTakeoff(oldData, searchString) {
      const filterData = filterTakeoff(oldData, searchString, this.limit)
      this.count = filterData.count
      this.takeoffs = filterData.currentResult
      this.loading = false
    },

    searchTakeoffs(oldData, searchString) {
      const filterData = filterTakeoffGrid(oldData, searchString, this.limit)
      this.count = filterData.count
      this.takeoffs = filterData.currentResult
      this.list = filterData.list
      this.loading = false
      if (this.gridOptions.api) {
        this.gridOptions.api.setRowData(this.list)
      }
    },

    getTakeoffs(searchText) {
      this.loading = true
      const searchString = searchText
      let url = `${dropdownAPIs.takeoff}?search=${searchText.slice(0, 3)}`
      if (this.params.colDef.cellRendererParams.screen === 'Project') {
        url = `${projectAPIs.master.takeoff.add(
          this.$route.params.id,
        )}?search=${searchText.slice(0, 3)}`
      }
      if (
        (this.prevSearchKey !== searchText && searchText.length === 3) ||
        (!this.prevSearchKey && searchText.length >= 3)
      ) {
        this.currentResult = []
        this.prevSearchKey = searchText
        instance
          .get(`${url}`)
          .then(res => {
            const result = _.get(res.data, 'result', [])
            this.list = []
            this.prevResult = JSON.stringify(result)
            const oldData =
              this.prevResult.length > 0 && searchString
                ? JSON.parse(this.prevResult)
                : []
            this.searchTakeoffs(oldData, searchString)
          })
          .catch(err => {
            this.loading = false
            errorService(err)
          })
      } else {
        const oldData =
          this.prevResult.length > 0 && searchText
            ? JSON.parse(this.prevResult)
            : []

        this.searchTakeoffs(oldData, searchString)
      }
    },

    saveData(value) {
      if (value !== 'viewAll') {
        this.takeoffs.forEach(data => {
          data.takeoffs.forEach(takeoff => {
            if (takeoff.key === value) {
              this.takeoffData = takeoff
              this.value = takeoff.key
            }
          })
        })
        this.saveMasterData(value)
      } else {
        this.visible = true
        this.getTakeoffs(this.prevSearchKey)
      }
    },

    saveMasterData(value) {
      value = this.takeoffData.takeoff
      switch (this.params.colDef.cellRendererParams.type) {
        case 'dynamicTable':
          this.$root.$emit(
            'handleChange',
            value,
            this.params.data,
            this.params.colDef.field,
            this.params.rowIndex,
            this.takeoffData,
          )
          break
        case 'analysisSheet':
          this.$root.$emit(
            'saveAnalysisData',
            value,
            this.params.data,
            this.params.colDef.field,
            this.params.rowIndex,
            this.takeoffData,
          )
          break
        default:
          this.$root.$emit(
            'saveTenantData',
            this.params.colDef.field,
            value,
            this.params.colDef.headerName,
            this.params.data,
            this.takeoffData ? this.takeoffData.id : undefined,
          )
          break
      }
    },

    handleOk() {
      this.visible = false
      this.value = this.searchText
    },

    handleCancel() {
      this.visible = false
      this.value = this.searchText
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      this.visible = false
      this.value = selectedData[0].takeoff
      this.$root.$emit(
        'handleChange',
        selectedData[0].takeoff,
        this.params.data,
        this.params.colDef.field,
        this.params.rowIndex,
        selectedData[0],
      )
    },

    clearFilter() {
      this.prevSearchKey = undefined
      this.prevResult = []
      this.takeoffs = []
      this.takeoffData = null
      this.list = []
      this.count = 0
      this.searchText = undefined
      this.gridOptions.api.setRowData([])
    },

    getValue() {
      if (this.takeoffData) {
        return this.takeoffData.takeoff
      } else {
        return this.takeoff
      }
    },
  },
})
